import { render } from "./SortableIcon.vue?vue&type=template&id=21ec39c8"
import script from "./SortableIcon.vue?vue&type=script&lang=js"
export * from "./SortableIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SortableIcon.vue"]])

export default __exports__